import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-field-errors',
  template: `
    <ng-container *ngIf="errors">
      <small
        *ngIf="errors.maxlength"
        class="p-error"
        [translate]="'TOAST.Field must be below X characters.'"
        [translateParams]="{ value: errors.maxlength.requiredLength }"
      >
      </small>
      <small *ngIf="errors.pattern" class="p-error">
        {{ errors.errorMessage }}
      </small>
      <small *ngIf="errors.required" class="p-error">
        This field is required!
      </small>
      <small *ngIf="errors.email" class="p-error">
        Enter valid email address.
      </small>
      <small *ngIf="errors.min" class="p-error">
        The minimum value you can enter is {{ errors.min.min }}.
      </small>
    </ng-container>
  `,
})
export class FieldErrorsComponent {
  /**
   * @description
   * Extracted logic for showing form control errors.
   * This component is used inside form builder.
   */

  /**
   * * Inputs
   * @errors Provide all errors from reactive forms
   */
  @Input() errors: any;
}
